import { SelectedApplianceDetails } from '../models/selected-appliance-details.interface';

export const mockSelectedApplianceDetails: SelectedApplianceDetails = {
  applianceCode: 'WASH123',
  applianceName: 'SuperWash 3000',
  brandName: 'WashMaster',
  manufacturer: 'WashMaster Inc.',
  purchaseMonth: 5,
  purchasePrice: '499.99',
  purchaseYear: '2023',
  wasBoughtWithin12Months: true,
};
